export function SurveyLoading() {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white">
      <div className="size-9 animate-spin rounded-full border-4 border-black/10 border-t-gray-600" />
    </div>
  );
}
